import JSBridge from 'sense-jsbridge';
import queryString from 'query-string';
import { getMarkingUrl } from '@/utils/log/logWithOriginUrl';
import env, { isInZhuzher, isLocal, isInWechat, isIos } from './env';
import { URL_LOCATION_KEY } from '@/utils/location';
import { URL_PROJECT_CODE_LOCAL_STORAGE_KEY } from '@/hooks/useProject';
import { logTrack } from './log';
import { tokenOfUrl } from './url';
// todo 接入助英台和企业微信，如果接口差异不大的话，统一包装一层；否则就分开各个sdk
const jsBridge = new JSBridge();

export default jsBridge;

type ICallback<D = any> = (data: D) => void;

/**
 * 获取项目信息
 */
export const getProject = (callback: ICallback) => {
  if (isInZhuzher) {
    jsBridge.getProject(res => {
      callback(res);
    });
  }
};
// 获取房屋信息
export const getMainHouse = (callback: ICallback) => {
  if (isInZhuzher) {
    jsBridge.getMainHouse(res => {
      callback(res);
    });
  }
};

/**
 * 显示TabBar
 * @deprecated 已作废
 */
export const showTabBar = () => {
  console.log('显示底部导航栏方法调用之前的条件判断 isInZhuzher', isInZhuzher);
  if (isInZhuzher) {
    console.log('显示底部导航栏方法调用');
    jsBridge.wvcontrol({ actionType: 0 }, data => {
      console.log('显示底部导航栏方法调用结果', data);
    });
  }
};

/**
 * 隐藏TabBar
 * @deprecated 已作废
 */
export const hideTabBar = () => {
  console.log('隐藏底部导航栏方法调用之前的条件判断 isInZhuzher', isInZhuzher);
  if (isInZhuzher) {
    console.log('隐藏底部导航栏方法调用');
    jsBridge.wvcontrol({ actionType: 1 }, data => {
      console.log('隐藏底部导航栏方法调用结果', data);
    });
  }
};
// 底部跳转到友邻市集
export const goTab = () => {
  if (isInZhuzher) {
    jsBridge.route('zze://vanke.com/main/main?tab=3');
  }
};
/**
 * 关闭webview
 */
export const closeWebView = () => {
  if (isInZhuzher) {
    jsBridge.wvcontrol({ actionType: 2 });
  }
};

/**
 * 新web窗口打开 url
 */
export const newWebView = (url: Location['href']) => {
  const { accessToken } = tokenOfUrl(location.search);
  // 使用缓存
  let localProject: Array<string> | string =
    localStorage.getItem(URL_PROJECT_CODE_LOCAL_STORAGE_KEY) || '[]';
  try {
    localProject = JSON.parse(localProject);
  } catch {
    localProject = [];
  }
  // 本地缓存可能是空数组，这里判断一下，免得把别人传进来的projectCode覆盖了
  let otherParam = {};
  if (localProject[0]) {
    otherParam = {
      projectCode: localProject[0],
      projectName: localProject[1],
    };
  }
  let tokenParam: Record<string, any> =
    url.indexOf(env.FG_HOST) === 0 ? { token: accessToken } : { accessToken };
  if (isInZhuzher) {
    tokenParam = {};
  }

  const parseUrl = queryString.parseUrl(url);
  const markingUrl = getMarkingUrl(
    queryString.stringifyUrl({
      url: parseUrl.url,
      query: { ...parseUrl.query, ...otherParam, ...tokenParam },
    }),
  );

  const logData: Record<string, string> = {
    url: markingUrl,
  };

  // url 的 moduleMark
  if (parseUrl.query.moduleMark) {
    logData.moduleMark = parseUrl.query.moduleMark.toString();
  }
  // url 的 pageMark
  if (parseUrl.query.pageMark) {
    logData.pageMark = parseUrl.query.pageMark.toString();
  }

  logTrack('newWebview', logData);

  console.log('isIos:', isIos);
  if (isInZhuzher) {
    jsBridge.wvcontrol({
      actionType: 3,
      // url: isIos ? encodeURIComponent(markingUrl) : markingUrl,
      url: markingUrl,
    });
  } else {
    window.open(markingUrl);
  }
};

/**
 * 隐藏titleBar
 */
export const hideTitleBar = () => {
  if (isInZhuzher) {
    jsBridge.wvcontrol({ actionType: 4 });
  }
};

/**
 * 显示titleBar
 */
export const showTitleBar = () => {
  if (isInZhuzher) {
    jsBridge.wvcontrol({ actionType: 5 });
  }
};

/**
 * 不占用电池栏
 */
export const excludeStatusBar = () => {
  console.log('不占用顶部状态栏方法调用');
  if (isInZhuzher) {
    jsBridge?.webviewNeedUseStatusBar?.(0, data => {
      console.log('不占用顶部状态栏方法调用结果', data);
    });
  }
};
/**
 * 占用电池栏
 */
export const includeStatusBar = () => {
  console.log('占用顶部状态栏方法调用');
  if (isInZhuzher) {
    jsBridge?.webviewNeedUseStatusBar?.(1, data => {
      console.log('占用顶部状态栏方法调用结果', data);
    });
  }
};

/**
 * webview显示
 */
export const onWebviewShow = (callback?: (data: any) => void) => {
  if (isInZhuzher) {
    jsBridge.registerHandler('resume', callback);
  }
};

type ISharePlatform = 'WECHAT_CHAT' | 'WECHAT_TIMELINE' | 'APP_CHAT';

type IShareParams = {
  title: string; // '标题',
  desc?: string; // '描述',
  link: string; // '链接',
  agentId?: string;
  // '图片(url,或者baseRequest4的图片数据)',
  // imgUrl 住这儿APP iOs 分享邻居聊天是必传
  imgUrl?: string;
  webpageUrl?: string; // '小程序失败时，备用跳转页面',
  program_id?: string; // '小程序原始ID，gh_xxxx',
  path?: string; // '小程序内部页面路径',
  // type: 'image', image：分享图片， webpage：分享，miniPro：小程序(也可直接根据program_id来判断)
  // type 在住这儿APP iOs下为必传
  type?: string;
  program_type: 0 | 1 | 2; // 0:release 生产 1:test 测试 2:preview 体验
  platform: ISharePlatform | ISharePlatform[]; // 'WECHAT_CHAT'// 平台: WECHAT_CHAT, WECHAT_TIMELINE,APP_CHAT(//4.1.2 分享到App群聊)
};

/**
 * params.platform 传入数组就调起原生分享列表，传入单个平台直接分享
 * @param params
 * @param callback
 */
export const share = (params: IShareParams, callback?: ICallback) => {
  if (Array.isArray(params.platform)) {
    jsBridge.shareByAppDialog(params, callback);
  } else {
    jsBridge.share(params, callback);
  }
};

/**
 * 4、获取业务token
 * @param params 实例
 * {
 *   type:0, //@Deprecated，推荐使用businessType  0-商城token，1-二手市场,不传默认为0//由于之前挖了坑，只支持了0和非0，现在用新字段bussinessType来表示
 *   businessType:0//0-商城token，1-二手市场，2-优惠券  //如果有bussinessType字段，先取bussinessType，不然再取type
 * }
 * @param response
 */
export enum tokenBusinessType {
  shop, // 0-商城token
  secondhand, // 1-二手市场
  coupon, // 2-优惠券
}
export const getUserToken = (
  type: tokenBusinessType,
  callback: ICallback<{ token: string }>,
) => {
  if (isInZhuzher) {
    jsBridge.getUserToken({ businessType: type }, res => {
      if (res.code === 0) {
        callback(res.data);
      } else {
        throw new Error(res.msg);
      }
    });
  }
};

/**
 * 5、获取app数据
 * @param response
 */
// {
//   code: 0, //0-调用成功  非0-调用失败
//   msg: '', //code非0时，表示具体的错误描述信息
//   data: {
//     avatar: '', //头像
//     mobile: '', //手机号
//     name: '', //昵称
//     token: '', //falcon token
//     userId: '', //falcon id //4.1.4
//     role: '', //用户身份     //4.1.4
//   },
// }
export const getUserBasic = (
  callback: ICallback<{
    avatar: string; // 头像
    mobile: string; // 手机号
    name: string; // 昵称
    token: string; // falcon token
    userId: string; // falcon id //4.1.4
    role: string; // 用户身份     //4.1.4
  }>,
) => {
  if (isInZhuzher) {
    jsBridge.getUserBasic(res => {
      if (res.code === 0) {
        callback(res.data);
      } else {
        throw new Error(res.msg);
      }
    });
  }
};

/**
 *
 * @param maxCount 最大上传数量
 * @param callback
 */
type IBase64Ary = string[];
export const selectImg = (
  maxCount: number,
  callback: ICallback<IBase64Ary>,
) => {
  if (isInZhuzher) {
    if (maxCount > 10) {
      throw new Error('最多选择10张');
    }
    jsBridge.selectImg(maxCount, res => {
      if (res.code === 0) {
        callback(res.data);
      } else {
        throw new Error(res.msg);
      }
    });
  }
};

/**
 * 订单拉起原生支付
 */
export const toPay = (orderId: string, orderPrice: number) => {
  return new Promise<{
    code?: number;
    msg?: string;
    data?: {
      ret?: number;
    };
  }>((resolve, reject) => {
    console.log('支付参数', {
      orderId,
      orderPrice,
    });
    jsBridge.newPay(
      {
        biz_type: '66',
        skipSuccessPage: true,
        orderId,
        orderPrice,
      },
      (res: {
        code?: number;
        msg?: string;
        data?: {
          ret?: number;
        };
      }) => {
        console.log('app支付结果', res);
        if (res?.code === 0 && res?.data?.ret === 0) {
          // 调用成功
          resolve(res);
        } else {
          // 调用失败
          reject(res);
        }
      },
    );
  });
};

// 获取定位信息
export const webLocate = () => {
  return new Promise<{
    longitude: number;
    latitude: number;
  }>((resolve, reject) => {
    if (isInZhuzher) {
      jsBridge.webLocate(
        (res?: {
          code: number;
          data: {
            longitude: number;
            latitude: number;
          };
        }) => {
          if (res?.code === 0) {
            resolve(res?.data);
          } else {
            reject();
          }
        },
      );
      return;
    }
    if (isInWechat) {
      const { latitude, longitude } = JSON.parse(
        localStorage.getItem(URL_LOCATION_KEY) as string,
      );
      if (latitude && longitude) {
        resolve({
          longitude,
          latitude,
        });
      } else {
        reject();
      }
    }
    if (isLocal) {
      navigator.geolocation.getCurrentPosition(
        position => {
          resolve({
            longitude: position.coords.longitude,
            latitude: position.coords.latitude,
          });
        },
        () => {
          reject();
        },
      );
      return;
    }
    reject();
  });
};
